import {
  FacultyRoute,
  examineeRoutes,
  permissions,
  questionApproverRoutes,
  questionCreatorRoutes,
  routes,
} from "../../../AppRoutes";
import { getItemfromStorage, setItemToStorage } from "./common-utils";
import { getRoleNameList } from "./shared-data.service";

export const getLeftNavs = () => {
  let finalRoutes: any = [];
  let role = getRoleNameList();

  if (role.includes("Question Creator")) {
    finalRoutes = [...finalRoutes, ...questionCreatorRoutes];
  }

  if (role.includes("Question Approver")) {
    finalRoutes = [...finalRoutes, ...questionApproverRoutes];
  }

  if (role.includes("Examinee")) {
    finalRoutes = [...finalRoutes, ...examineeRoutes];
  }

  if (role.includes("Exam Creator")) {
    const rts: any = routes[2].routes?.filter((i) =>
      i.accessLevel?.includes("Exam Creator")
    );
    finalRoutes = [...finalRoutes, ...rts];
  }

  if (role.includes("Exam Approver")) {
    const rts: any = routes[2].routes?.filter((i) =>
    i.accessLevel?.includes("Exam Approver")
    );
    finalRoutes = [...finalRoutes, ...rts];
  }



  if (role.includes("Admin") || role.includes("Academic Cordinator")) {
    console.log('role', role);
    const rts: any = routes[2].routes;
    console.log('rts: ', rts);
    finalRoutes = [...finalRoutes, ...rts];
  }

  if (role.includes("Faculty")) {
    finalRoutes = [...finalRoutes, ...FacultyRoute];
  }

  const changePasswordRoute = routes[2].routes?.filter(route => route.name === "change");
  finalRoutes = [...finalRoutes, ...changePasswordRoute as any []];

//  if (!role.includes("Admin")) {
  finalRoutes = finalRoutes.filter(
    (tag, index, array) => array.findIndex((t) => t.name === tag.name) === index
  );
//  }

  console.log('finalRoutes: ', finalRoutes);
  return finalRoutes;
};
export const getHomePage = () => {
  return getLeftNavs()?.[0].path;
};
export const checkPermission = (buttonName: string) => {
  return (
    getRoleNameList().includes("Admin") ||
    getRoleNameList().some((rl) => permissions?.[rl]?.[buttonName])
  );
};
export const setEditQuestion = (val: boolean) => {
  setItemToStorage("edit_question", val);
};

export const getEditQuestion = () => {
  return getItemfromStorage("edit_question");
};

export const setExamInfo = (val: object[]) => {
  setItemToStorage("exam_info", val);
};

export const getExamInfo = () => {
  return getItemfromStorage("exam_info");
};

export const setSelectedExamInfo = (val: object) => {
  setItemToStorage("selectedExamInfo", val);
};

export const getSelectedExamInfo = () => {
  return getItemfromStorage("selectedExamInfo");
};
